import { Flex, Text } from '@/uicomponents';
import { type WizardStep } from './steps';
import styles from './wizard-tabs.module.css';

interface TabItemProps {
  step: WizardStep;
  isActive: boolean;
}

export const TabItem = ({ step, isActive }: TabItemProps) => {
  const tabClass = isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab;
  const dotClass = isActive ? `${styles.dot} ${styles.dotActive}` : styles.dot;
  const labelClass = isActive ? styles.labelActive : styles.label;
  const ariaCurrent = isActive ? 'step' : undefined;
  return (
    <Flex
      flex={1}
      align='center'
      justify='center'
      gap={8}
      aria-current={ariaCurrent}
      className={tabClass}
    >
      {/* zero-width space prevents antd's `.ant-flex:empty { display: none }` from hiding the dot */}
      <Flex aria-hidden='true' className={dotClass}>
        {'​'}
      </Flex>
      {/* T6 — the step name is an eyebrow (10px Roboto 600 ALL CAPS, 0.06em). `variant`
          carries the whole treatment; only the colour is set locally. The label is still
          uppercased here rather than by `text-transform` alone so the step's accessible
          name keeps matching what is painted. */}
      <Text variant='eyebrow' className={labelClass}>
        {step.label.toUpperCase()}
      </Text>
    </Flex>
  );
};
